export default __webpack_public_path__ + "static/media/investment_n.32cc6935.svg";